import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/main/home'
import List from '@/components/main/list'
import Lable from '@/components/main/lable'
import Login from '@/components/main/login'
import User from '@/components/main/user'
import Add from '@/components/main/add'
import Test from '@/components/main/test'
import Ac from '@/components/main/ac'
import Acbao from '@/components/main/Acbao'
import Acst from '@/components/main/acst'
import Acstb from '@/components/main/acstb'
import nAc from '@/components/main/nac'
import nAcbao from '@/components/main/nAcbao'
import nAcst from '@/components/main/nacst'
import nAcstb from '@/components/main/nacstb'
import Tj from '@/components/main/tj'
import Tz from '@/components/main/tz'
import Key from '@/components/main/key'
import Arkey from '@/components/main/arkey'
import Nkey from '@/components/main/nkey'
import Keyself from '@/components/main/keyself'
import Arkeyself from '@/components/main/arkeyself'
import Nkeyself from '@/components/main/nkeyself'
import Keys from '@/components/main/keys'
import Keyo from '@/components/main/keyo'
import Arkeyo from '@/components/main/arkeyo'
import Nkeyo from '@/components/main/nkeyo'
import Ai from '@/components/main/ai'
import Arai from '@/components/main/arai'
import Nai from '@/components/main/nai'
import Dz from '@/components/main/dz'
import Ob from '@/components/main/orderby'
import Tui from '@/components/main/tui'
import Tuic from '@/components/main/tuic'
import MuBiao from '@/components/main/mubiao'
import MuBiaoK from '@/components/main/mubiaok'
import MuBiaoKt from '@/components/main/mubiaokt'
import MuBiaoo from '@/components/main/mubiaoo'
import MuBiaot from '@/components/main/mubiaot'
import MuBiaoKo from '@/components/main/mubiaoko'
import ArmuBiao from '@/components/main/armubiao'
import ArmuBiaoK from '@/components/main/armubiaok'
import ArmuBiaot from '@/components/main/armubiaot'
import ArmuBiaoKt from '@/components/main/armubiaokt'
import ArmuBiaoo from '@/components/main/armubiaoo'
import ArmuBiaoKo from '@/components/main/armubiaoko'
import NmuBiao from '@/components/main/nmubiao'
import NmuBiaoK from '@/components/main/nmubiaok'
import NmuBiaoo from '@/components/main/nmubiaoo'
import NmuBiaoKo from '@/components/main/nmubiaoko'
import Tiao from '@/components/main/tiao'
import Artiaotwo from '@/components/main/artiaotwo'
import TiaoTwo from '@/components/main/tiaotwo'
import Tiaow from '@/components/main/tiaow'
import Artiaow from '@/components/main/artiaow'
import Tiaowt from '@/components/main/tiaowt'
import Artiaowt from '@/components/main/artiaowt'
import Tiaowtt from '@/components/main/tiaowtt'
import Artiaowtt from '@/components/main/artiaowtt'
import Artiao from '@/components/main/artiao'
import Ntiao from '@/components/main/ntiao'
import Upload from '@/components/main/upload'
import Image from '@/components/main/image'
import ImageX from '@/components/main/imagex'
import ImageT from '@/components/main/imaget'
import STui from '@/components/main/stui'
import STime from '@/components/main/stime'
import Comge from '@/components/main/comge'
import Comgf from '@/components/main/comgf'
import Acg from '@/components/main/acg'
import Nacg from '@/components/main/nacg'
import Acb from '@/components/main/acb'
import Act from '@/components/main/act'
import Ach from '@/components/main/ach'
import Acj from '@/components/main/acj'
import Quanqiuyoulan from '@/components/main/quanqiuyoulan'
import Kuaidi from '@/components/main/kuaidi'
import Elementsh from '@/components/main/elementsh'
import Elementshyb from '@/components/main/elementshyb'
import Elementshneibu from '@/components/main/elementshneibu'
import Elementshbiaoshi from '@/components/main/elementshbiaoshi'
import Elementshcp from '@/components/main/elementshcp'
import Elementshcpj from '@/components/main/elementshcpj'
import Elementshsb from '@/components/main/elementshsb'
import Elementshtf from '@/components/main/elementshtf'
import Elementshjz from '@/components/main/elementshjz'
import Elementshdq from '@/components/main/elementshdq'
import Elementsssb from '@/components/main/elementsssb'
import Elementssdq from '@/components/main/elementssdq'
import Elementzx from '@/components/main/elementzx'
import Elementzxdq from '@/components/main/elementzxdq'
import Elementfx from '@/components/main/elementfx'
import Elementfxsb from '@/components/main/elementfxsb'
import Elementzxs from '@/components/main/elementzxs'
import Elementfxs from '@/components/main/elementfxs'
import Elementlx from '@/components/main/elementlx'
import Elementlxs from '@/components/main/elementlxs'
import Elementdt from '@/components/main/elementdt'
import Elementdtb from '@/components/main/elementdtb'
import Elementdtsb from '@/components/main/elementdtsb'
import Elementdttui from '@/components/main/elementdttui'
import Elementdtl from '@/components/main/elementdtl'
import Elementdts from '@/components/main/elementdts'
import Ceshi from '@/components/main/ceshi'
import Ciku from '@/components/main/Ciku'
import Shipin from '@/components/main/shipin'
import Snews from '@/components/main/snews'
import Smusic from '@/components/main/smusic'
import Sgood from '@/components/main/sgood'
import Sbaike from '@/components/main/sbaike'
import Wangzhi from '@/components/main/wangzhi'
import Wangzhis from '@/components/main/wangzhis'
import Wangzhig from '@/components/main/wangzhig'
import Equipment from '@/components/main/equipment'
import Equipmentc from '@/components/main/equipmentc'
import Equipmentcf from '@/components/main/equipmentcf'
import Equipmentck from '@/components/main/equipmentck'
import Equipmentz from '@/components/main/equipmentz'
import Equipmentzf from '@/components/main/equipmentzf'
import Equipmentzk from '@/components/main/equipmentzk'
import Equipmentw from '@/components/main/equipmentw'
import Xianliurc from '@/components/main/xianliurc'
import Xianliuch from '@/components/main/xianliuch'
import Xianliucc from '@/components/main/xianliucc'
import Xianliux from '@/components/main/xianliux'
import Xianliurcd from '@/components/main/xianliurcd'
import Xianliuxd from '@/components/main/xianliuxd'
import Aexcel from '@/components/main/aexcel'
import Xexcel from '@/components/main/xexcel'
import Gexcel from '@/components/main/gexcel'
import G2excel from '@/components/main/g2excel'
import Kexcel from '@/components/main/kexcel'
import Sexcel from '@/components/main/sexcel'
import Wexcel from '@/components/main/wexcel'
import Zglexcel from '@/components/main/zglexcel'
import Gnglexcel from '@/components/main/gnglexcel'
import Selfexcel from '@/components/main/selfexcel'
import Seach from '@/components/main/seach'
import Qianming from '@/components/main/qianming'
import Nseach from '@/components/main/nseach'
import Gtell from '@/components/main/gtell'
import Gmsg from '@/components/main/gmsg'
import Gapp from '@/components/main/gapp'
import Goodtui from '@/components/main/goodtui'
import Wangzhitui from '@/components/main/wangzhitui'
import Dibiaotui from '@/components/main/dibiaotui'
import Arstate from '@/components/main/arstate'
import Youxi from '@/components/main/youxi'
import Youxitui from '@/components/main/youxitui'
import Acimg from '@/components/main/acimg'
import Acimgm from '@/components/main/acimgm'
import Qw from '@/components/main/qw'
import Qa from '@/components/main/qa'
import Qadata from '@/components/main/qadata'
import Qxdata from '@/components/main/qxdata'
import Qwdata from '@/components/main/qwdata'
import Qx from '@/components/main/qx'
import Qswicth from '@/components/main/qswicth'
import Qwax from '@/components/main/qwax'
import Qwaxd from '@/components/main/qwaxd'
import ElementUp from '@/components/main/elementUp'
import Fxweizhi from '@/components/main/fxweizhi'
import Fxdingwei from '@/components/main/fxdingwei'
import Fxzhibo from '@/components/main/fxzhibo'
import Wendang from '@/components/main/wendang'
import Talk from '@/components/main/talk'
import Elementhuanrao from '@/components/main/elementhuanrao'
import Redisdata from '@/components/main/redisdata'
import Qredis from '@/components/main/qredis'
import Qsredis from '@/components/main/qsredis'
import Wzuobiao from '@/components/main/wzuobiao'
import Wmanhua from '@/components/main/wmanhua'
import Whetong from '@/components/main/whetong'
import Wdaolan from '@/components/main/wdaolan'
import Wneibu from '@/components/main/wneibu'
import Wzhibo from '@/components/main/wzhibo'
import Sduowei from '@/components/main/sduowei'
import Gtells from '@/components/main/gtells'
import Qxtdata from '@/components/main/qxtdata'
import Qwtdata from '@/components/main/qwtdata'
import Qatdata from '@/components/main/qatdata'
import Wshangr from '@/components/main/wshangr'
import Wshangd from '@/components/main/wshangd'
import Open from '@/components/main/open'
import Cjieba from '@/components/main/cjieba'
import Cjiebax from '@/components/main/cjiebax'
import Acfuzhi from '@/components/main/acfuzhi'
import Acfuzhib from '@/components/main/acfuzhib'
import Acfuzhic from '@/components/main/acfuzhic'
import Acfuzhih from '@/components/main/acfuzhih'
import Zhiling from '@/components/main/zhiling'
Vue.use(Router)

export default new Router({
  mode: 'history',
  bash: '/',
  routes: [
    {
      path: '/',
      component: Login
    },
  {
    path: '/zhiling',
    name: 'Zhiling',
    component: Zhiling
  },
	{
	  path: '/open',
	  name: 'Open',
	  component: Open
	},
  {
    path: '/acfuzhi',
    name: 'Acfuzhi',
    component: Acfuzhi
  },
  {
    path: '/acfuzhib',
    name: 'Acfuzhib',
    component: Acfuzhib
  },
  {
    path: '/acfuzhic',
    name: 'Acfuzhic',
    component: Acfuzhic
  },
  {
    path: '/acfuzhih',
    name: 'Acfuzhih',
    component: Acfuzhih
  },
   {
     path: '/cjieba',
     name: 'Cjieba',
     component: Cjieba
   },
   {
     path: '/cjiebax',
     name: 'Cjiebax',
     component: Cjiebax
   },
	{
	   path: '/wshangr',
	   name: 'Wshangr',
	   component: Wshangr
	 },
	 {
	   path: '/wshangd',
	   name: 'Wshangd',
	   component: Wshangd
	 },
	 {
	   path: '/qatdata',
	   name: 'Qatdata',
	   component: Qatdata
	 },
	 {
	   path: '/qwtdata',
	   name: 'Qwtdata',
	   component: Qwtdata
	 },
	 {
	   path: '/qxtdata',
	   name: 'Qxtdata',
	   component: Qxtdata
	 },
	 {
	   path: '/gtells',
	   name: 'Gtells',
	   component: Gtells
	 },
	 {
	   path: '/sduowei',
	   name: 'Sduowei',
	   component: Sduowei
	 },
	{
	  path: '/wmanhua',
	  name: 'Wmanhua',
	  component: Wmanhua
	},
	{
	  path: '/whetong',
	  name: 'Whetong',
	  component: Whetong
	},
	{
	  path: '/wzuobiao',
	  name: 'Wzuobiao',
	  component: Wzuobiao
	},
	{
	  path: '/wdaolan',
	  name: 'Wdaolan',
	  component: Wdaolan
	},
	{
	  path: '/wneibu',
	  name: 'Wneibu',
	  component: Wneibu
	},
	{
	  path: '/wzhibo',
	  name: 'Wzhibo',
	  component: Wzhibo
	},
    {
      path: '/redisdata',
      name: 'Redisdata',
      component: Redisdata
    },
    {
      path: '/qredis',
      name: 'Qredis',
      component: Qredis
    },
    {
      path: '/qsredis',
      name: 'Qsredis',
      component: Qsredis
    },
    {
      path: '/elementUp',
      name: 'ElementUp',
      component: ElementUp
    },
    {
      path: '/talk',
      name: 'Talk',
      component: Talk
    },
    {
      path: '/elementhuanrao',
      name: 'Elementhuanrao',
      component: Elementhuanrao
    },
    {
      path: '/qwaxd',
      name: 'Qwaxd',
      meta:{'title':'1111111'},
      component: Qwaxd
    },
    {
      path: '/qwax',
      name: 'Qwax',
      component: Qwax
    },
    {
      path: '/qswicth',
      name: 'Qswicth',

      component: Qswicth
    },
    {
      path: '/qw',
      name: 'Qw',
      component: Qw
    },
    {
      path: '/qa',
      name: 'Qa',
      component: Qa
    },
    {
      path: '/qadata',
      name: 'Qadata',
      component: Qadata
    },
    {
      path: '/qwdata',
      name: 'Qwdata',
      component: Qwdata
    },
    {
      path: '/qx',
      name: 'Qx',
      component: Qx
    },
    {
      path: '/qxdata',
      name: 'Qxdata',
      component: Qxdata
    },
    {
      path: '/arstate',
      name: 'Arstate',
      component: Arstate
    },
    {
      path: '/acimg',
      name: 'Acimg',
      component: Acimg
    },
    {
      path: '/acimgm',
      name: 'Acimgm',
      component: Acimgm
    },
    {
      path: '/youxi',
      name: 'Youxi',
      component: Youxi
    },
    {
      path: '/youxitui',
      name: 'Youxitui',
      component: Youxitui
    },
    {
      path: '/dibiaotui',
      name: 'Dibiaotui',
      component: Dibiaotui
    },
    {
      path: '/goodtui',
      name: 'Goodtui',
      component: Goodtui
    },
    {
      path: '/wangzhitui',
      name: 'Wangzhitui',
      component: Wangzhitui
    },
    {
      path: '/gtell',
      name: 'Gtell',
      component: Gtell
    },
    {
      path: '/gapp',
      name: 'Gapp',
      component: Gapp
    },
    {
      path: '/gmsg',
      name: 'Gmsg',
      component: Gmsg
    },
    {
      path: '/zglexcel',
      name: 'Zglexcel',
      component: Zglexcel
    },
    {
      path: '/quanqiuyoulan',
      name: 'Quanqiuyoulan',
      component: Quanqiuyoulan
    },
    {
      path: '/ciku',
      name: 'Ciku',
      component: Ciku
    },
    {
      path: '/gnglexcel',
      name: 'Gnglexcel',
      component: Gnglexcel
    },
    {
      path: '/aexcel',
      name: 'Aexcel',
      component: Aexcel
    },
    {
      path: '/qianming',
      name: 'Qianming',
      component: Qianming
    },
    {
      path: '/xexcel',
      name: 'Xexcel',
      component: Xexcel
    },
    {
      path: '/seach',
      name: 'Seach',
      component: Seach
    },
    {
      path: '/nseach',
      name: 'Nseach',
      component: Nseach
    },
    {
      path: '/kexcel',
      name: 'Kexcel',
      component: Kexcel
    },
    {
      path: '/gexcel',
      name: 'Gexcel',
      component: Gexcel
    },
    {
      path: '/g2excel',
      name: 'G2excel',
      component: G2excel
    },
    {
      path: '/sexcel',
      name: 'Sexcel',
      component: Sexcel
    },
    {
      path: '/wexcel',
      name: 'Wexcel',
      component: Wexcel
    },
    {
      path: '/selfexcel',
      name: 'Selfexcel',
      component: Selfexcel
    },
    {
      path: '/xianliux',
      name: 'Xianliux',
      component: Xianliux
    },
    {
      path: '/xianliuxd',
      name: 'Xianliuxd',
      component: Xianliuxd
    },
    {
      path: '/xianliurc',
      name: 'Xianliurc',
      component: Xianliurc
    },
    {
      path: '/xianliurcd',
      name: 'Xianliurcd',
      component: Xianliurcd
    },
    {
      path: '/xianliuch',
      name: 'Xianliuch',
      component: Xianliuch
    },
    {
      path: '/xianliucc',
      name: 'Xianliucc',
      component: Xianliucc
    },
    {
      path: '/elementsh',
      name: 'Elementsh',
      component: Elementsh
    },
    {
      path: '/shipin',
      name: 'Shipin',
      component: Shipin
    },
	{
	  path: '/snews',
	  name: 'Snews',
	  component: Snews
	},
	{
	  path: '/smusic',
	  name: 'Smusic',
	  component: Smusic
	},
  {
    path: '/sgood',
    name: 'Sgood',
    component: Sgood
  },
  {
    path: '/sbaike',
    name: 'Sbaike',
    component: Sbaike
  },
    {
      path: '/wangzhi',
      name: 'Wangzhi',
      component: Wangzhi
    },
    {
      path: '/wangzhis',
      name: 'Wangzhis',
      component: Wangzhis
    },
    {
      path: '/wangzhig',
      name: 'Wangzhig',
      component: Wangzhig
    },
    {
      path: '/act',
      name: 'Act',
      component: Act
    },
    {
      path: '/acst',
      name: 'Acst',
      component: Acst
    },
    {
      path: '/acstb',
      name: 'Acstb',
      component: Acstb
    },
    {
      path: '/nacst',
      name: 'nAcst',
      component: nAcst
    },
    {
      path: '/nacstb',
      name: 'nAcstb',
      component: nAcstb
    },
    {
      path: '/elementshyb',
      name: 'Elementshyb',
      component: Elementshyb
    },
    {
      path: '/elementshneibu',
      name: 'Elementshneibu',
      component: Elementshneibu
    },
    {
      path: '/elementshbiaoshi',
      name: 'Elementshbiaoshi',
      component: Elementshbiaoshi
    },
	{
	  path: '/kuaidi',
	  name: 'Kuaidi',
	  component: Kuaidi
	},
    {
      path: '/elementshcp',
      name: 'Elementshcp',
      component: Elementshcp
    },
    {
      path: '/elementshcpj',
      name: 'Elementshcpj',
      component: Elementshcpj
    },
    {
      path: '/elementshsb',
      name: 'Elementshsb',
      component: Elementshsb
    },
    {
      path: '/elementshtf',
      name: 'Elementshtf',
      component: Elementshtf
    },
    {
      path: '/elementshjz',
      name: 'Elementshjz',
      component: Elementshjz
    },
    {
      path: '/elementshdq',
      name: 'Elementshdq',
      component: Elementshdq
    },
    {
      path: '/elementsssb',
      name: 'Elementsssb',
      component: Elementsssb
    },
    {
      path: '/elementssdq',
      name: 'Elementssdq',
      component: Elementssdq
    },
    {
      path: '/equipment',
      name: 'Equipment',
      component: Equipment
    },
    {
      path: '/equipmentc',
      name: 'Equipmentc',
      component: Equipmentc
    },
    {
      path: '/equipmentz',
      name: 'Equipmentz',
      component: Equipmentz
    },
    {
      path: '/wendang',
      name: 'Wendang',
      component: Wendang
    },
    {
      path: '/equipmentzf',
      name: 'Equipmentzf',
      component: Equipmentzf
    },
    {
      path: '/equipmentzk',
      name: 'Equipmentzk',
      component: Equipmentzk
    },
    {
      path: '/equipmentcf',
      name: 'Equipmentcf',
      component: Equipmentcf
    },
    {
      path: '/equipmentck',
      name: 'Equipmentck',
      component: Equipmentck
    },
    {
      path: '/equipmentw',
      name: 'Equipmentw',
      component: Equipmentw
    },
    {
      path: '/fxweizhi',
      name: 'Fxweizhi',
      component: Fxweizhi
    },
    {
      path: '/fxdingwei',
      name: 'Fxdingwei',
      component: Fxdingwei
    },
    {
      path: '/fxzhibo',
      name: 'Fxzhibo',
      component: Fxzhibo
    },
    {
      path: '/elementdt',
      name: 'Elementdt',
      component: Elementdt
    },
    {
      path: '/elementdtb',
      name: 'Elementdtb',
      component: Elementdtb
    },
    {
      path: '/elementdtsb',
      name: 'Elementdtsb',
      component: Elementdtsb
    },
	{
	  path: '/elementdttui',
	  name: 'Elementdttui',
	  component: Elementdttui
	},
    {
      path: '/elementdtl',
      name: 'Elementdtl',
      component: Elementdtl
    },
    {
      path: '/elementdts',
      name: 'Elementdts',
      component: Elementdts
    },
    {
      path: '/ceshi',
      name: 'Ceshi',
      component: Ceshi
    },
    {
      path: '/elementzx',
      name: 'Elementzx',
      component: Elementzx
    },
    {
      path: '/elementzxdq',
      name: 'Elementzxdq',
      component: Elementzxdq
    },
    {
      path: '/elementfx',
      name: 'Elementfx',
      component: Elementfx
    },
    {
      path: '/elementfxsb',
      name: 'Elementfxsb',
      component: Elementfxsb
    },
    {
      path: '/elementlx',
      name: 'Elementlx',
      component: Elementlx
    },

    {
      path: '/elementzxs',
      name: 'Elementzxs',
      component: Elementzxs
    },
    {
      path: '/elementfxs',
      name: 'Elementfxs',
      component: Elementfxs
    },
    {
      path: '/elementlxs',
      name: 'Elementlxs',
      component: Elementlxs
    },
    {
      path: '/home',
      name: 'Home',
      component: Home
    },
    {
      path: '/list',
      name: 'List',
      component: List
    },
		{
		  path: '/lable',
		  name: 'Lable',
		  component: Lable
		},
		{
		  path: '/user',
		  name: 'User',
		  component: User
		},
		{
		  path: '/add',
		  name: 'Add',
		  component: Add
		},
		{
		  path: '/test',
		  name: 'Test',
		  component: Test
		},
		{
		  path: '/ac',
		  name: 'Ac',
		  component: Ac
		},
    {
      path: '/acbao',
      name: 'Acbao',
      component: Acbao
    },
    {
      path: '/nac',
      name: 'nAc',
      component: nAc
    },
    {
      path: '/nacbao',
      name: 'nAcbao',
      component: nAcbao
    },
    {
      path: '/acg',
      name: 'Acg',
      component: Acg
    },
    {
      path: '/nacg',
      name: 'Nacg',
      component: Nacg
    },
    {
      path: '/acb',
      name: 'Acb',
      component: Acb
    },
    {
      path: '/ach',
      name: 'Ach',
      component: Ach
    },
    {
      path: '/acj',
      name: 'Acj',
      component: Acj
    },
		{
		  path: '/tj',
		  name: 'Tj',
		  component: Tj
		},
    {
      path: '/tz',
      name: 'Tz',
      component: Tz
    },
    {
      path: '/key',
      name: 'Key',
      component: Key
    },
    {
      path: '/arkey',
      name: 'Arkey',
      component: Arkey
    },
    {
      path: '/nkey',
      name: 'Nkey',
      component: Nkey
    },
    {
      path: '/keyself',
      name: 'Keyself',
      component: Keyself
    },
    {
      path: '/arkeyself',
      name: 'Arkeyself',
      component: Arkeyself
    },
    {
      path: '/nkeyself',
      name: 'Nkeyself',
      component: Nkeyself
    },
    {
      path: '/keys',
      name: 'Keys',
      component: Keys
    },
    {
      path: '/keyo',
      name: 'Keyo',
      component: Keyo
    },
    {
      path: '/arkeyo',
      name: 'Arkeyo',
      component: Arkeyo
    },
    {
      path: '/nkeyo',
      name: 'Nkeyo',
      component: Nkeyo
    },
    {
      path: '/arai',
      name: 'Arai',
      component: Arai
    },
    {
      path: '/ai',
      name: 'Ai',
      component: Ai
    },
    {
      path: '/nai',
      name: 'Nai',
      component: Nai
    },
    {
      path: '/dz',
      name: 'Dz',
      component: Dz
    },
    {
      path: '/ob',
      name: 'Ob',
      component: Ob
    },
    {
      path: '/tui',
      name: 'Tui',
      component:Tui
    },
    {
      path: '/tuic',
      name: 'Tuic',
      component:Tuic
    },
    {
      path: '/mubiao',
      name: 'MuBiao',
      component:MuBiao
    },
    {
      path: '/mubiaok',
      name: 'MuBiaoK',
      component:MuBiaoK
    },
    {
          path: '/mubiaoo',
          name: 'MuBiaoo',
          component:MuBiaoo
    },
    {
          path: '/mubiaot',
          name: 'MuBiaot',
          component:MuBiaot
    },
    {
      path: '/mubiaoko',
      name: 'MuBiaoKo',
      component:MuBiaoKo
    },
    {
      path: '/mubiaokt',
      name: 'MuBiaoKt',
      component:MuBiaoKt
    },
    {
      path: '/armubiao',
      name: 'ArmuBiao',
      component:ArmuBiao
    },
    {
      path: '/armubiaot',
      name: 'ArmuBiaot',
      component:ArmuBiaot
    },
    {
      path: '/armubiaok',
      name: 'ArmuBiaoK',
      component:ArmuBiaoK
    },
    {
      path: '/armubiaokt',
      name: 'ArmuBiaoKt',
      component:ArmuBiaoKt
    },

    {
          path: '/armubiaoo',
          name: 'ArmuBiaoo',
          component:ArmuBiaoo
    },
    {
      path: '/armubiaoko',
      name: 'ArmuBiaoKo',
      component:ArmuBiaoKo
    },
    {
      path: '/tiao',
      name: 'Tiao',
      component:Tiao
    },
    {
      path: '/tiaotwo',
      name: 'TiaoTwo',
      component:TiaoTwo
    },
    {
      path: '/tiaow',
      name: 'Tiaow',
      component:Tiaow
    },
    {
      path: '/tiaowt',
      name: 'Tiaowt',
      component:Tiaowt
    },
    {
      path: '/tiaowtt',
      name: 'Tiaowtt',
      component:Tiaowtt
    },
    {
      path: '/artiaow',
      name: 'Artiaow',
      component:Artiaow
    },
    {
      path: '/artiaowt',
      name: 'Artiaowt',
      component:Artiaowt
    },
    {
      path: '/artiaowtt',
      name: 'Artiaowtt',
      component:Artiaowtt
    },
    {
      path: '/artiao',
      name: 'Artiao',
      component:Artiao
    },
    {
      path: '/artiaotwo',
      name: 'Artiaotwo',
      component:Artiaotwo
    },
    {
      path: '/nmubiao',
      name: 'NmuBiao',
      component:NmuBiao
    },
    {
      path: '/nmubiaok',
      name: 'NmuBiaoK',
      component:NmuBiaoK
    },
    {
          path: '/nmubiaoo',
          name: 'NmuBiaoo',
          component:NmuBiaoo
    },
    {
      path: '/nmuBiaoko',
      name: 'NmuBiaoKo',
      component:NmuBiaoKo
    },
    {
      path: '/ntiao',
      name: 'Ntiao',
      component:Ntiao
    },
    {
      path: '/image',
      name: 'Image',
      component:Image
    },
    {
      path: '/imagex',
      name: 'ImageX',
      component:ImageX
    },
    {
      path: '/imaget',
      name: 'ImageT',
      component:ImageT
    },
    {
      path: '/upload',
      name: 'Upload',
      component:Upload
    },
    {
	      path: '/stui',
	      name: 'STui',
	      component:STui
	    },
     {
         path: '/stime',
         name: 'STime',
         component:STime
       },
       {
           path: '/comge',
           name: 'Comge',
           component:Comge
         },
         {
           path: '/comgf',
           name: 'Comgf',
           component:Comgf
         },






    { path: '*', redirect: '/' }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js